export const baseUrl = "https://api.smartlearner.com";
export const imageBaseUrl = "https://api.smartlearner.com/uploads/";
